import React from 'react';
import AnyeMosca2Svg from '../../images/ilustrations/Anye_mosca2_new.svg';

const AnyeMosca2 = () => (
    <img src={AnyeMosca2Svg} alt="Mosca" style={{ width: '1.5em', height: '1.5em' }} />
);

export default AnyeMosca2;
